<template>
  <v-dialog v-model="dialog" fullscreen content-class="primary">

    <v-container class="w-75 d-flex justify-center align-center flex-column full-height" >

      <span class="titles text-h4 font-weight-medium white--text py-3 d-flex justify-center" >
        {{ $t('challenge.prize_breakdown') }}
      </span>
      <v-card class="pa-5 border-radius-2 w-100">
        <v-img
          :src="require('../../assets/img/effects/corner-badge.svg')"
          elevation="6"
          contain
          class="card-number corner-number"
          v-if="!isInitialReader"
        >
          <h1 class="number-icon-card" style="margin-top:30px; color: #ff6f3a">2</h1>
        </v-img>
        <v-container fluid class="">
          <v-row>
            <v-col cols="3" v-for="(data, index) of informationData" :key="index">
              <div class="d-flex justify-center align-center flex-column full-height" >
                <span class="primary--text text-h3">{{data.qtyQuestion}}</span>
                <span class="primary--text text-body-2 font-weight-bold w-60" >{{$t('challenge.you_win')}}</span>
                <img :src="data.informationImg" alt="prize image" class="mt-auto"/>
                <div
                  class="primary white--text border-radius-1 mt-n10 px-3 py-1 font-size-14 w-70 font-weight-bold"
                  :style="{'line-height': '3vh'}"
                >
                  {{data.value}}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            data-cy="continue-button-prize_breakdown"
            color="secondary"
            class="px-15"
            large
            rounded
            @click="startChallenge"
          >
            {{ $t('challenge.initial_text_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-container>

  </v-dialog>
</template>

<script>
  import initialReaderValidation from '@/mixins/InitialReaderValidation'
  import { mapActions, mapState } from 'vuex'

  export default {
      name: 'PrizeBreakdown',
      props: {
          dialog: { type: Boolean, default: false },
      },
      computed: {
          ...mapState({
              course: (state) => state.userData.user.course, 
          }),
      },
      data() {
          return {
              informationData: [
                  {
                      qtyQuestion: '4',
                      // eslint-disable-next-line global-require
                      informationImg: require('@/assets/img/gamifications/20beecoins.svg'),
                      value: this.$t('challenge.win4'),
                  },
                  {
                      qtyQuestion: '3',
                      // eslint-disable-next-line global-require
                      informationImg: require('@/assets/img/gamifications/15beecoins.svg'),
                      value: this.$t('challenge.win3'),
                  },
                  {
                      qtyQuestion: '2',
                      // eslint-disable-next-line global-require
                      informationImg: require('@/assets/img/gamifications/10beecoins.svg'),
                      value: this.$t('challenge.win2'),
                  },
                  {
                      qtyQuestion: '1',
                      // eslint-disable-next-line global-require
                      informationImg: require('@/assets/img/gamifications/5beecoins.svg'),
                      value: this.$t('challenge.win1'),
                  },
              ],
          }
      },
      methods: {
          ...mapActions('challenge', [
              'setChallengeStage',
              'setReadingTime',
              'setReReadingTime'
          ]),
          startChallenge(){
              this.setChallengeStage('runChallenge')
              this.setReadingTime(new Date().getTime())

          }
      },
    mixins: [initialReaderValidation]
  }
</script>

<style scoped>
  .full-height {
    height: 100%;
  }

  .full-vh-height {
      height: 100vh;
  }

  .corner-number {
    position: absolute;
    left: -40px;
    top: -30px;
    width: 7vw;
    height: 8vw;
  }

  .corner-premessage-square {
    position: absolute; 
    background-color: white; 
    left: 0px; 
    top: 0px; 
    border-radius: 0 !important; 
    box-shadow: none !important;
  }

  .bee-1 {
    position: absolute; 
    right: -40px;
    top: -50px; 
    width: 130px
  }

  .bee-2 {
    position: absolute; 
    left: 380px; 
    bottom: -45px; 
    width: 130px
  }

  .premessage-font-title {
    font-style: normal;
    font-weight: 700; 
    font-size: 44px; 
    color: #4F4870
  }

  .premessage-font-text {
    font-style: normal;
    font-weight: 400; 
    font-size: 22px; 
    color: #4F4870
  }
</style>
